export const AppConfig = {
  app: "AutopilotQA",
  company: "Autopilot QA Technologies Inc.",
  organization: "Testdel",
};

export const TableConfig = {
  ITEMS_PER_PAGE: 20,
};
